import e from "create-emotion";
import r from "create-emotion-server";

var t = function () {
  var r = {
    key: "leafygreen-ui"
  };

  if ("undefined" != typeof window) {
    r.container = document.createElement("div");
    var t = document.head;
    t.insertBefore(r.container, t.firstChild);
  }

  return e(r);
}(),
    o = t.flush,
    n = t.hydrate,
    i = t.cx,
    a = t.merge,
    c = t.getRegisteredStyles,
    d = t.injectGlobal,
    f = t.keyframes,
    m = t.css,
    s = t.sheet,
    l = t.cache,
    u = r(l),
    y = u.extractCritical,
    h = u.renderStylesToString,
    g = u.renderStylesToNodeStream;

export default t;
export { l as cache, m as css, i as cx, y as extractCritical, o as flush, c as getRegisteredStyles, n as hydrate, d as injectGlobal, f as keyframes, a as merge, g as renderStylesToNodeStream, h as renderStylesToString, s as sheet };